import { Provider } from 'function-tree'

export default (...args) => {
  return new Provider(...args)
}
